module.exports = __webpack_public_path__ + "static/img/2_3_1.88d17c1a.jpg";